import styled from "styled-components";

export const TextContainer = styled.div `
    width: 40%;
    min-width: 350px;
    padding: 10px;
    justify-content: center;
    align-items: center;
`